import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
    faArrowCircleUp,
    faArrowLeft,
    faArrowRight,
    faChevronDown,
    faCheck,
    faSearch,
    faTruck,
    faDollarSign,
    faClock,
    faUser,
    faShoppingCart,
    faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
    faFacebook,
    faYoutube,
    faTwitter,
    faInstagram
} from "@fortawesome/free-brands-svg-icons";

/**
 * Loads the required Fontawesome icons
 *
 * @see https://fontawesome.com/how-to-use/on-the-web/advanced/svg-javascript-core
 */
export default function() {
    library.add(
        faArrowLeft,
        faArrowRight,
        faArrowCircleUp,
        faCheck,
        faFacebook,
        faChevronDown,
        faYoutube,
        faTwitter,
        faInstagram,
        faSearch,
        faTruck,
        faDollarSign,
        faClock,
        faUser,
        faShoppingCart,
        faPhone
    );
    dom.watch();
}
